import React, { Component } from 'react';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Badge
} from 'reactstrap';
import PropTypes from 'prop-types';

import {
  AppHeaderDropdown,
  AppNavbarBrand,
  AppSidebarToggler
} from '@coreui/react';
import logo from '../../assets/img/vettri-vela-logo-text.png';

import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { auth } from '../../firebase';
import { fetchMinutes } from '../../redux/actions/ChittieAuctionActions/fetchMinutes';
import { fetchChittiesByAuctions } from '../../redux/actions/ChittiesActions/fetchChittiesByAuctions';
import { logoutUser } from '../../redux/actions/LogoutActions/logoutUser';
import { Link } from 'react-router-dom';

const propTypes = {
  children: PropTypes.node,
  authUser: PropTypes.object,
  dispatch: PropTypes.func,
  chittieAuctions: PropTypes.object,
  chitties: PropTypes.object
};

const defaultProps = {};

class DefaultHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.dispatch(fetchMinutes());
    this.props.dispatch(fetchChittiesByAuctions());
  }

  logout = () => {
    this.props.dispatch(logoutUser());
    auth.doSignOut();
    toast.success('Signed out successfully');
  };

  render() {
    this.minutesFilling = Object.keys(this.props.chittieAuctions).length || 0;
    this.chittyClosure = Object.keys(this.props.chitties).length || 0;
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    const loggedMailId = this.props.authUser.authUser.email;
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand full={{ src: logo, alt: 'VettriVela' }} />
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <Nav className="ml-auto" navbar>
          <NavItem className="d-md-down-none">
            <NavLink href="/minutes">
              <i className="icon-bell" />
              <Badge pill color="danger">
                {this.minutesFilling > 99 ? '99+' : this.minutesFilling}
              </Badge>
            </NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="/chitClosure">
              <i className="icon-envelope-letter" />
              <Badge pill color="primary">
                {this.chittyClosure > 99 ? '99+' : this.chittyClosure}
              </Badge>
            </NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">{loggedMailId}</NavItem>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <i className="fa fa-ellipsis-v" />
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              <DropdownItem header tag="div" className="text-center">
                <strong>Settings</strong>
              </DropdownItem>
              <Link to={'/profile'} style={{textDecoration : 'none'}}>
                <DropdownItem>
                  <i className="fa fa-user" /> Profile
                </DropdownItem>
              </Link>
              <DropdownItem onClick={this.logout}>
                <i className="fa fa-lock" /> Logout
              </DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser,
  chittieAuctions: state.chittieAuctionState.minutes,
  chitties: state.chittiesState.completedChitties
});

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;
export default connect(mapStateToProps)(DefaultHeader);



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js